(function($){
$(document).ready(function() {

    $('.liste-diapos-accueil').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        // pauseOnHover: true,
        // pauseOnFocus: true,
        // focusOnSelect: true,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 2000,
        fade: true,
        cssEase: 'ease-out',
    });

    $('.liste-home-ressources').slick({
        autoplay: false,
        autoplaySpeed: 6000,
        pauseOnHover: true,
        pauseOnFocus: true,
        focusOnSelect: true,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        fade: true,
        cssEase: 'ease-out',
    });

    $('body').on('mouseenter','.ressource-body, .ressources .section-title', function(){
        // $(this).parents(".ressource").addClass('hover');
        $(".ressources .section-title, .ressource").addClass('hover');
    });
    $('body').on('mouseleave', '.ressources .section-title, .ressource-body', function(){
        // $(this).parents(".ressource").removeClass('hover');
        // $(this).parents(".ressources").children(".section-title").removeClass('hover');
        $(".ressources .section-title, .ressource").removeClass('hover');
    });

}); // document.ready
})(jQuery);
